import { Link } from '@remix-run/react'
import { Fragment } from 'react'
import { Icon } from '../icons/Icon'

type BreadcrumbItem = {
  url?: string
  label: string
}

type Props = {
  items: BreadcrumbItem[]
  variant?: 'dark' | 'light'
  className?: string
}
export const Breadcrumb = ({ items, variant = 'dark', className }: Props) => {
  return (
    <div
      className={`
        flex flex-nowrap items-center gap-2 overflow-hidden px-5 py-5

        lg:pl-0

        ${className ?? ''}
      `}
    >
      {items.map((item, index) => (
        <Fragment key={index}>
          {item.url ? (
            <Link
              to={item.url}
              className={`
                text-subtitle1-medium

                ${index === items.length - 1 ? 'truncate' : 'whitespace-nowrap'}
                ${
                  index === items.length - 1
                    ? 'text-neutral-900'
                    : `text-neutral-200`
                }
              `}
            >
              {item.label}
            </Link>
          ) : (
            <div
              className={`
                text-subtitle1-medium

                ${index === items.length - 1 ? 'truncate' : 'whitespace-nowrap'}
                ${variant === 'dark' ? `text-neutral-900` : `text-white`}
              `}
            >
              {item.label}
            </div>
          )}
          {index < items.length - 1 && (
            <div
              className={`
                flex h-3 w-3 items-center justify-center rounded-full border

                ${
                  variant === 'dark'
                    ? `border-neutral-100 bg-white`
                    : `border-neutral-200`
                }
              `}
            >
              <Icon
                name="basic/chevron-right"
                size="12px"
                className={`
                  ${variant === 'dark' ? `text-neutral-300` : `text-neutral-200`}
                `}
              />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  )
}

export const breadcrumbHome = {
  url: '/',
  label: 'Gama Óptima',
}
